"use strict"

let paymentId = 0;

function addPayment() {
    const container = $(this).closest('.panel').find('.group-tickets-input-table .ticket-container')
    const template = container.find('.template').clone()
    template.html(template.html()
        .replace(/%key/g, 'new_' + paymentId.toString())
        .replace(/%name/g, template.data('name'))
        .replace(/%id/g, template.data('id'))
        .replace(/%paymentId/g, paymentId.toString())
    )
    template.find('input').prop('disabled', false)
    template.appendTo(container).removeClass('template hidden').addClass('ticket-row')
    template.attr('aria-label', template.attr('aria-label').replace(/%paymentId/g, paymentId.toString()));
    paymentId++
    const radios = container.find('.ticket-row ._r_default')
    if (radios.length > 0 && !radios.is(':checked')) {
        radios.first().prop('checked', true)
    }
    return false
}

function deletePayment() {
    const container = $(this).closest('.ticket-row')
    if (container.find('input[name*="[id]"]').val().substring(0, 3) === 'new') {
        container.remove()
    } else {
        container.toggleClass('disabled')
        refreshRow(container)
    }
    return false;
}

function refreshRow(row) {
    row.find('input').prop('readonly', row.hasClass('disabled'))
    row.find('._enabled').val(row.hasClass('disabled') ? 0 : 1)
    row.find('.delete-button .glyphicon')
        .removeClass('glyphicon-remove glyphicon-ok')
        .addClass(row.hasClass('disabled') ? 'glyphicon-ok' : 'glyphicon-remove')
}

export default function (context) {
    paymentId = $('.group-tickets-input-table .ticket-row', context).length
    $('.add-payment', context).on('click', addPayment)
    const tables = $('.group-tickets-input-table', context)
    tables.on('click', '.delete-button', deletePayment)
    tables.on('keyup', '.delete-button', function(e){
        if(e.key === 'Enter' || e.key === ' ') {
            deletePayment.bind(this)(e);
        }
    })
    tables.find('._enabled[value!="1"]').each(function () {
        refreshRow($(this).closest('.ticket-row').addClass('disabled'));
    })
    tables.each(function () {
        // Search for default ticket.
        let defItem = $(this).find('input[name*="[is_default]"][value="1"]').closest('.ticket-row')
        // In case no default - set the first found.
        // if (defItem.length === 0) {
        //     defItem = $(this).find('tbody tr:not(.disabled):first')
        // }
        defItem.find('._r_default').click()
    })
    $('form.edit-group-form', context).on('submitting.coing', function () {
        $(this).find('.group-tickets-input-table')
            .find('.ticket-row input').prop('disabled', false)
    }).on('submitted.coing', function () {
        $(this).find('.group-tickets-input-table .ticket-row').each(function () {
            refreshRow($(this))
        })
    })

}
